module.exports = __webpack_public_path__ + "img/music-promotion-results.d9cd66cb.jpg";